export default __webpack_public_path__ + "static/media/Women-of-Reproductive-Age.bb6e31aa.png";